export default __webpack_public_path__ + "static/media/tenant-techbook.994c28f5.png";